export const routePrefixes = {
    pl: "pogoda24",
};

export const dayStringMultiple = {
    pl: "weekendowa",
    dach: "wochenend",
} as const;

export const dayStringSingle = {
    pl: "na-jutro",
    dach: "morgen",
} as const;

export const dayStringToday = {
    pl: "dzisiaj",
    // no equivalent in DACH
} as const;
